import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./style";

export const Unauthorized = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.container} mt={40} p={3}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        {t("unauthorized.accessRestricted")}
      </Typography>
      <Typography variant="body1">
        {t("unauthorized.dontHaveAccess")}
        <br />
        Please contact <strong>APA Well Organization</strong> to request role
        assignment.
      </Typography>
    </Box>
  );
};
